import {
  ClickAwayListener,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
  useTheme,
} from "@material-ui/core";
import React, {Fragment, useState} from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import useStyles from "./NavigationBar.css";
import translation from "../../i18n/i18.json";
import { NavigationPaths } from "../../constants/AppConstants";
import { Common } from "../../utils/Common";
import { ApprovalPointUtil } from "../../utils/ApprovalPointUtil";
import { ChevronRight,ChevronLeft,HomeOutlined,History, 
  Help, Assessment,AccountCircle, PlayCircleOutline, Add, Edit, Extension
  , Block, RadioButtonChecked, RadioButtonUnchecked, SupervisedUserCircle,ChangeHistory,BlockSharp } from "@material-ui/icons";
import AllActions from "../../actions";
import { useDispatch } from "react-redux";
import { Slideshow } from "@mui/icons-material";
import { VendorDetailState } from "../../reducers/vendor/VendorDetailReducer";
import { RootState } from "../../reducers";
import { useSelector } from "react-redux";
import {
    InforDisplyaDuration,
    DocumentType,
    SupportDocumentName
} from "../../constants/AppConstants";
import { FileDownloadService } from "../../services/FileDownloadService";
import FolderIcon from "@material-ui/icons/FolderSpecial";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export default function NavigationBar(props: any) {
  const classes = useStyles();
  const theme = useTheme();
  const { isMenuOpen, setisMenuOpen, userfile } = props;
  const [openHelpMenu, setOpenHelpMenu ] = useState(false);
  const [openHelpDocMenu, setOpenHelpDocMenu ] = useState(false);
  const [openHelpDeskTooltip, setOpenHelpDeskTooltip ] = useState(false);
  //const { editable, userfile, requestNumber, onFileUpload } = props;

  const dispatch = useDispatch();

  const handleDrawerOpen = () => {
    setisMenuOpen(true);
  };

  const handleDrawerClose = () => {
    setisMenuOpen(false);
    setOpenHelpMenu(false);
  };

  const handleHelpClick = () => {
    if(!openHelpMenu){
      setisMenuOpen(true);
    }
    setOpenHelpMenu(!openHelpMenu);
    
  };
  const handleSupportDocClick = () => {
    if(!openHelpDocMenu){
      setisMenuOpen(true);
    }
    setOpenHelpDocMenu(!openHelpDocMenu);
  };
  const handleTooltipClose = () => {
    setOpenHelpDeskTooltip(false);
  };

  const handleTooltipOpen = () => {
    setOpenHelpDeskTooltip(true);
  };

  const handleSupportDocView = (docName: SupportDocumentName) => {
    handleDownload(false,true, docName);
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  const prepareForRequest = () => {
      dispatch(AllActions.backDropActions.openBackDrop());
  };

   const vendorDetail: VendorDetailState = useSelector<
      RootState,
      VendorDetailState
    >((state) => state.vendorDetails);

  const handleHelpVideoClick = (videoName:string) => {
    if(videoName){
      dispatch(AllActions.videoDialogActions.openVideoDialog(
        translation.main_menu_help_howto_title,
        translation.main_menu_help_howto_title,
        translation.main_menu_help_howto_close,
        function () {
                dispatch(AllActions.videoDialogActions.closeVideoDialog());
        },
        function () {},
        videoName
    ));
    }
  };

 const handleDownload = (isView:boolean, isDownload:boolean, docName:SupportDocumentName) => {
     // e.preventDefault();
      prepareForRequest();
      FileDownloadService.downlodFile(
        { fileId: 0, fileName: `${docName}.pdf`, filePath: "" },
        isDownload,
        isView,
        DocumentType.SupportDocument.toString(),
        docName.toString(),
        function(success:any){
          compeleteRequest(true);
  
      }, function(error:any){
         compeleteRequest(false, translation.file_download_filedwnld_err);
  
      });
    };
 

  let menuitems = [
    {
      label: translation.main_menu_dashboard,
      icon: <HomeOutlined />,
      path: NavigationPaths.Dashboard,
    },
    {
      label: translation.main_menu_report,
      icon: <Assessment />,
      path: NavigationPaths.Report,
    },
    {
      label: translation.main_menu_history_mangemnet,
      icon: <History />,
      path: NavigationPaths.HistoryManagement,
    },
  ];

  if (ApprovalPointUtil.isAdmin("")) {
    menuitems.push({
      label: translation.main_menu_master_usermangemnet,
      icon: <AccountCircle />,
      path: NavigationPaths.UserManagement,
    });
    menuitems.push({
      label: translation.main_menu_user_mangemnet_history,
      icon: <SupervisedUserCircle />,
      path: NavigationPaths.UserHistoryManagement,
    });
     menuitems.push({
      label: translation.main_menu_procurementcategory_masterdata,
      icon: <ChangeHistory />,
      path: NavigationPaths.ProcurementCategory,
    });
    menuitems.push({
      label: translation.main_menu_Vendor_Block_Execmption,
      icon: <BlockSharp />,
      path: NavigationPaths.VendorBlockExcemption,
    });
   
  }
  
   

  return (
    <div>
      <div>
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: isMenuOpen,
            [classes.drawerClose]: !isMenuOpen,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: isMenuOpen,
              [classes.drawerClose]: !isMenuOpen,
            }),
          }}
        >
          <div className={classes.leftToolbar}>
            {/* className={classes.leftToolbar} */}
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRight />
              ) : (
                <ChevronLeft />
              )}
            </IconButton>
          </div>
          <List>
            {!Common.isVendor() && (
               <> 
               {
                  menuitems.map((mobj, index) => (
                    <ListItem
                      button
                      key={mobj.label}
                      component={Link}
                      to={mobj.path}
                    >
                      <Tooltip title={mobj.label} placement="right">
                        <ListItemIcon>{mobj.icon} </ListItemIcon>
                      </Tooltip>
                      <ListItemText primary={mobj.label} />
                    </ListItem>
                  )) 
              }
              <ListItem button key={translation.main_menu_help_vedio} className="bganimate"
                onClick={handleHelpClick}>
                <Tooltip title={translation.main_menu_help_vedio} placement="right">
                  <ListItemIcon><Slideshow /></ListItemIcon>
                </Tooltip>
                <ListItemText primary={translation.main_menu_help_vedio} />
              </ListItem> 
              <Collapse in={openHelpMenu} timeout="auto" unmountOnExit>
                <List>
                  <ListItem button 
                    key={translation.main_menu_help_howto_create} 
                    onClick={ () => {handleHelpVideoClick('VendorCreationRequestor.webm')}}
                    style={{paddingTop:0}}>
                    <Tooltip title={translation.main_menu_help_howto_create} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><Add /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={translation.main_menu_help_howto_create} />
                  </ListItem>
                  <ListItem button 
                    key={translation.main_menu_help_howto_amend} 
                    onClick={ () => {handleHelpVideoClick('VendorAmendmentRequestor.webm')}}
                    style={{paddingTop:0}}>
                    <Tooltip title={translation.main_menu_help_howto_amend} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><Edit /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={translation.main_menu_help_howto_amend} />
                  </ListItem>
                  <ListItem button 
                    key={translation.main_menu_help_howto_extend} 
                    onClick={ () => {handleHelpVideoClick('VendorExtension.webm')}}
                    style={{paddingTop:0}}>
                    <Tooltip title={translation.main_menu_help_howto_extend} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><Extension /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={translation.main_menu_help_howto_extend} />
                  </ListItem>
                  <ListItem button 
                    key={translation.main_menu_help_howto_block} 
                    onClick={ () => {handleHelpVideoClick('VendorBlock.webm')}}
                    style={{paddingTop:0}}>
                    <Tooltip title={translation.main_menu_help_howto_block} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><Block /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={translation.main_menu_help_howto_block} />
                  </ListItem>
                  <ListItem button 
                    key={translation.main_menu_help_howto_unblock} 
                    onClick={ () => {handleHelpVideoClick('VendorUnblock.webm')}}
                    style={{paddingTop:0}}>
                    <Tooltip title={translation.main_menu_help_howto_unblock} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><RadioButtonUnchecked /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={translation.main_menu_help_howto_unblock} />
                  </ListItem>
                </List>
              </Collapse> 

              <ListItem button key={translation.main_menu_support} onClick={handleSupportDocClick}>
                <Tooltip title={translation.main_menu_support} placement="right">
                  <ListItemIcon><FolderIcon /></ListItemIcon>
                </Tooltip>
                <ListItemText primary={translation.main_menu_support} />
              </ListItem> 
               <Collapse in={openHelpDocMenu} timeout="auto" unmountOnExit>
                <List>
                  <ListItem button key={translation.main_menu_Support_Darwin_RM_view_Doc} onClick={() => {handleSupportDocView(SupportDocumentName.SOPDocumentDarwinRm)} }
                    style={{paddingTop:0}}> 
                     <Tooltip title={translation.main_menu_Support_Darwin_RM_view_Doc} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><PictureAsPdfIcon /></ListItemIcon>
                     </Tooltip>
                     <ListItemText primary={translation.main_menu_Support_Darwin_RM_view_Doc} />     
                  </ListItem> 
                  <ListItem button key={translation.main_menu_Support_Darwin_NRM_view_Doc} onClick={() => {handleSupportDocView(SupportDocumentName.SOPDocumentDarwinNrm) }}
                    style={{paddingTop:0}}> 
                     <Tooltip title={translation.main_menu_Support_Darwin_NRM_view_Doc} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><PictureAsPdfIcon /></ListItemIcon>
                     </Tooltip>
                     <ListItemText primary={translation.main_menu_Support_Darwin_NRM_view_Doc} />     
                  </ListItem> 
                  <ListItem button key={translation.main_menu_Support_S4_RM_view_Doc} onClick={() => {handleSupportDocView(SupportDocumentName.SOPDocumentS4Rm) }}
                    style={{paddingTop:0}}> 
                     <Tooltip title={translation.main_menu_Support_S4_RM_view_Doc} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><PictureAsPdfIcon /></ListItemIcon>
                     </Tooltip>
                     <ListItemText primary={translation.main_menu_Support_S4_RM_view_Doc} />     
                  </ListItem> 
                  <ListItem button key={translation.main_menu_Support_S4_NRM_view_Doc} onClick={() => {handleSupportDocView(SupportDocumentName.SOPDocumentS4Nrm)} }
                    style={{paddingTop:0}}> 
                     <Tooltip title={translation.main_menu_Support_S4_NRM_view_Doc} placement="right">
                      <ListItemIcon style={{minWidth: 40, marginLeft:10}}><PictureAsPdfIcon /></ListItemIcon>
                     </Tooltip>
                     <ListItemText primary={translation.main_menu_Support_S4_NRM_view_Doc} />     
                  </ListItem> 
                  <ClickAwayListener onClickAway={handleTooltipClose}>
                    <div>
                    <Tooltip title={<p>M +94 74-0919369, +94 74-3499397, +94 74-0964673, +94 74-0919283</p> } 
                      placement="right"
                      onClose={handleTooltipClose}
                      open={openHelpDeskTooltip}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      interactive
                      >
                        <ListItem button key={translation.main_menu_help} onClick={handleTooltipOpen}>
                        <ListItemIcon style={{minWidth: 40, marginLeft:10}}><Help /></ListItemIcon>
                          <ListItemText primary={translation.main_menu_help} />
                        </ListItem> 
                        </Tooltip>
                    </div>
                    </ClickAwayListener>
                </List>
              </Collapse> 
            </>
            )}
            {
              Common.isVendor() && (
                <Fragment>
                   <ListItem button key={translation.main_menu_help_vedio}
                    onClick={handleHelpClick}>
                    <Tooltip title={translation.main_menu_help_vedio} placement="right">
                      <ListItemIcon><Help /></ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={translation.main_menu_help_vedio} />
                  </ListItem> 
                  <Collapse in={openHelpMenu} timeout="auto" unmountOnExit>
                    <List>
                      <ListItem button 
                        key={translation.main_menu_help_howto_create} 
                        onClick={ () => {handleHelpVideoClick('VendorCreationVendor.webm')}}
                        style={{paddingTop:0}}>
                        <Tooltip title={translation.main_menu_help_howto_create} placement="right">
                          <ListItemIcon style={{minWidth: 40, marginLeft:10}}><Add /></ListItemIcon>
                        </Tooltip>
                        <ListItemText primary={translation.main_menu_help_howto_create} />
                      </ListItem>
                      <ListItem button 
                        key={translation.main_menu_help_howto_amend} 
                        onClick={ () => {handleHelpVideoClick('VendorAmendmentVendor.webm')}}
                        style={{paddingTop:0}}>
                        <Tooltip title={translation.main_menu_help_howto_amend} placement="right">
                          <ListItemIcon style={{minWidth: 40, marginLeft:10}}><Edit /></ListItemIcon>
                        </Tooltip>
                        <ListItemText primary={translation.main_menu_help_howto_amend} />
                      </ListItem>
                    </List>
                  </Collapse> 
                </Fragment>
              )
            }
            {/*<ClickAwayListener onClickAway={handleTooltipClose}>
              <div>
 
                <Tooltip title={<p>M +94 74-0919369, +94 74-3499397, +94 74-0964673, +94 74-0919283</p> } 
                  placement="right"
                  onClose={handleTooltipClose}
                  open={openHelpDeskTooltip}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  interactive
                  >
                    <ListItem button key={translation.main_menu_help} onClick={handleTooltipOpen}>
                    <ListItemIcon><Help /></ListItemIcon>
                      <ListItemText primary={translation.main_menu_help} />
                    </ListItem> 
                    </Tooltip>
                
              </div>
            </ClickAwayListener>
            */}
            <div className={classes.footerTxtWrapper}>
              &#169; { new Date().getFullYear() } All Rights Reserved.
            </div>
          </List>
        </Drawer>
      </div>
    </div>
  );
}
